import { render, staticRenderFns } from "./UpdateMass.vue?vue&type=template&id=70b7d6f7&"
import script from "./UpdateMass.vue?vue&type=script&lang=js&"
export * from "./UpdateMass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports